import LiteratureExpertIcon from "@mui/icons-material/LocalLibrary";
import { useFormikContext } from "formik";
import { FormattedMessage } from "react-intl";

import { PredictorIcon } from "@citrine/atoms/icons";
import type { SelectOption } from "@citrine/atoms/select";

import type { CatalystMode } from "#src/contexts/catalyst";

import * as sx from "./mode-selector.sx";
import { TEST_IDS } from "./utils";

const OPTIONS: SelectOption<CatalystMode>[] = [
  {
    label: <FormattedMessage id="catalyst.literature-expert.abbreviation" />,
    value: "literature-expert",
  },
  {
    label: <FormattedMessage id="catalyst.model-expert.abbreviation" />,
    value: "model-expert",
  },
];

export function ModeSelector({
  disabled,
  onChange,
  value,
}: {
  disabled?: boolean;
  onChange: (value: CatalystMode) => void;
  value: CatalystMode;
}) {
  const { isSubmitting } = useFormikContext();

  return (
    <sx.Select
      data-fullstoryid="catalyst.mode-selector"
      data-testid={TEST_IDS.modeSelector}
      disabled={disabled || isSubmitting}
      onChange={(event) => {
        onChange(event.target.value as CatalystMode);
      }}
      options={OPTIONS}
      startAdornment={
        value === "model-expert" ? (
          <PredictorIcon fontSize="small" />
        ) : (
          <LiteratureExpertIcon fontSize="small" color="info" />
        )
      }
      value={value}
      variant="filled"
    />
  );
}
